<!-- components/Footer.vue -->
<template>
  <footer>
    <div class="footer-content">
      <div class="footer-section">
        <p>{{ lMessages["about"] }}</p>
        <div class="map-placeholder">
          <img
            :src="logo"
            @mouseover="logo = logo_blue"
            @mouseout="logo = logo_white"
            alt=""
            style="padding: 0; height: 1.6rem"
          />
        </div>
      </div>
      <div class="footer-section">
        <p>{{ lMessages["title"] }}</p>
        <div class="map-placeholder">
          {{ lMessages["tel"] }}<br />
          {{ lMessages["address"] }}<br />
          {{ lMessages["city"] }}
        </div>
      </div>
      <div class="footer-section map">
        <p>{{ lMessages["offices"] }}</p>
        <div class="map-placeholder">
          <iframe
            height="100%"
            width="100%"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            src="https://www.google.com/maps/d/embed?mid=1UHDM8PnRlMydPy3oicoO4gISJnARqh4&ehbc=2E312F"
          ></iframe>
        </div>
      </div>
    </div>
    <p class="copyright mt-2">
      {{ lMessages["copyright"] }}
    </p>
  </footer>
</template>

<script>
export default {
  props: {
    lMessages: { required: true, default: () => [] }
  },
  data() {
    return {
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg")
    };
  }
};
</script>

<style scoped>
p {
  font-size: 1.3rem;
  color: var(--textInactiveFixed);
}

footer {
  height: 270px;
  background: var(--lightBackgroundFixed);
  color: var(--white);
  padding: 2rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto 2rem;
}

.footer-section {
  text-align: left;
}

h4 {
  margin-bottom: 1rem;
}

a {
  color: var(--white);
  text-decoration: none;
  display: block;
  margin-bottom: 0.5rem;
}

.social-icons {
  display: flex;
  gap: 1rem;
}

.map-placeholder {
  color: var(--white);
  width: 100%;
  height: 100px;
  align-items: center;
  justify-content: center;
  border-radius: 0;
}

.copyright {
  color: var(--white)!important;
  text-align: center;
  font-size: 0.9rem;
}
</style>
